var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 10,
  viewBox: "0 0 16 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 0c4.418 0 8 4.286 8 5s-3.582 5-8 5-8-4.286-8-5 3.582-5 8-5m0 1.429C4.787 1.429 2.182 4.286 2.182 5S4.787 8.571 8 8.571 13.818 5.714 13.818 5 11.213 1.429 8 1.429m0 .714c1.607 0 2.91 1.279 2.91 2.857S9.606 7.857 8 7.857 5.09 6.578 5.09 5c0-.293.046-.576.13-.843.227.497.735.843 1.325.843C7.35 5 8 4.36 8 3.571c0-.58-.352-1.078-.857-1.302A3 3 0 0 1 8 2.143"
})));
export default SvgEye;